import * as ScrollArea from "@radix-ui/react-scroll-area";
import styled from "styled-components";

export const ScrollAreaWrapper = styled(ScrollArea.Root)`
  flex: 1 1 auto;
  overflow: scroll;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs5};
  flex-wrap: nowrap;
  overflow: hidden;
  min-width: 0;
  width: 100%;
`;
